import React from 'react'
import { formatDateDDMMYYYY, formatDateHM } from '../../apps/professional-app/fa/common/aifeatures/utils'

const getFormattedMeetingDate = (startedAt: string, finishedAt?: string) => {
  const actualDate = new Date()
  const startedAtDate = new Date(startedAt)
  const isSameDay =
    startedAtDate.getDate() === actualDate.getDate() &&
    startedAtDate.getMonth() === actualDate.getMonth() &&
    startedAtDate.getFullYear() === actualDate.getFullYear()
  const datePart = isSameDay ? '' : formatDateDDMMYYYY(startedAt) + ' '
  const timePart = `${formatDateHM(startedAt)}-${finishedAt ? formatDateHM(finishedAt) : 'Live'}`
  return `${datePart}${timePart}`
}

export interface MeetingDateDisplayProps {
  startedAt: string
  finishedAt?: string
}

export const MeetingDateDisplay: React.FC<MeetingDateDisplayProps> = ({ startedAt, finishedAt }) => {
  return <div className='lead-small zocks-text-gray-900'>{getFormattedMeetingDate(startedAt, finishedAt)}</div>
}
